import { render } from "./EmployeeManagement.vue?vue&type=template&id=4db7958b&scoped=true"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js"

import "./EmployeeManagement.vue?vue&type=style&index=0&id=4db7958b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db7958b"]])

export default __exports__